import type { FilterDefinitionType, FilterType } from "@/components/@types";
import { FilterChip } from "@/components/organisms/UtilityBar/FilterChip";
import { FilterChipPopper } from "@/components/organisms/UtilityBar/FilterChip/FilterChipPopper";
import { FilterChipStateProvider } from "@/components/organisms/UtilityBar/FilterChip/FilterChipStateContext";

export function ReportsViewWidgetHeaderFilters({
  filters,
  filterDefinitions,
  onChange,
}: {
  filters: FilterType[];
  filterDefinitions: Record<string, FilterDefinitionType>;
  onChange: (filters: FilterType[]) => void;
}) {
  if (Object.keys(filterDefinitions).length === 0) {
    return null;
  }

  return (
    <FilterChipStateProvider
      filters={filters}
      filterDefinitions={filterDefinitions}
      onFiltersChange={onChange}
    >
      <div className="flex justify-end overflow-x-auto overflow-y-visible min-w-0 max-w-full [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
        <div className="flex flex-row flex-nowrap items-center justify-end gap-1 w-max min-w-min">
          {filters.map((filter, filterIndex) => (
            <FilterChip
              key={filter.key}
              filterKey={filter.key}
              filter={filter}
              filterIndex={filterIndex}
              showLockToggle
            />
          ))}
          <FilterChipPopper />
        </div>
      </div>
    </FilterChipStateProvider>
  );
}
